'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["allowRawLinksOnly", "popoverType", "relAttr", "linkType", "onLinkTypeChange", "onUpdate", "onSubmit", "onClose", "renderLinkPopoverAlert"];
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useLinkValidation } from '../../hooks/useLinkValidation';
import { isWhitespace } from '../../utils/url';
import { PopoverType, KeyTypes } from '../../constants/popover';
import ExplicitSaveControls from '../ExplicitSaveControls';
import MorphingPopoverBody from '../MorphingPopoverBody';
import LinkPopoverControlsV2 from './LinkPopoverControlsV2';
import LinkAdvancedPopoverControls from './LinkAdvancedPopoverControls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.${suffix}`;
const propTypes = Object.assign({}, LinkPopoverControlsV2.propTypes, {
  popoverType: PropTypes.oneOf(Object.values(PopoverType)),
  relAttr: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  renderLinkPopoverAlert: PropTypes.func
});
function MorphingLinkPopoverBody(props) {
  const {
      allowRawLinksOnly,
      popoverType,
      relAttr,
      linkType,
      onLinkTypeChange,
      onUpdate,
      onSubmit,
      onClose,
      renderLinkPopoverAlert
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [handleLinkTypeChange, handleUpdate, handleSubmit] = useLinkValidation({
    linkType: props.linkType,
    href: props.href,
    isValidLink: props.isValidLink,
    onLinkTypeChange,
    onUpdate,
    onSubmit
  });
  const handleCloseOnEscape = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      onClose();
    }
  };
  const handleRelAttrChange = value => {
    handleUpdate({
      relAttr: value
    });
  };
  const isSubmitDisabled = isWhitespace(props.href) || isWhitespace(props.linkText) && !allowRawLinksOnly;
  let morphingPopoverProps = {};
  if (props.showRefAndTargetControls) {
    // Only show the advanced link controls for non-email contexts
    morphingPopoverProps = {
      morphButtonTitle: i18nKey('advanced.title'),
      morphedContentTitle: i18nKey('advanced.title'),
      renderMorphedContent: ({
        onCloseMorphedContent
      }) => /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(LinkAdvancedPopoverControls, {
          relAttr: relAttr,
          onRelAttrChange: handleRelAttrChange,
          tooltipClassName: props.tooltipClassName
        }), /*#__PURE__*/_jsx(ExplicitSaveControls, {
          className: "m-top-3",
          popoverType: popoverType,
          isSubmitDisabled: isSubmitDisabled,
          linkType: linkType,
          onSubmit: () => {
            const success = handleSubmit();
            if (!success) {
              onCloseMorphedContent();
            }
          },
          onCancel: onClose
        })]
      })
    };
  }
  return /*#__PURE__*/_jsx(MorphingPopoverBody, Object.assign({
    title: i18nKey(`${popoverType}Title`)
  }, morphingPopoverProps, {
    children: /*#__PURE__*/_jsxs("div", {
      onKeyDown: handleCloseOnEscape,
      children: [/*#__PURE__*/_jsx(LinkPopoverControlsV2, Object.assign({}, rest, {
        linkType: linkType,
        onLinkTypeChange: handleLinkTypeChange,
        onUpdate: handleUpdate,
        onSubmit: handleSubmit,
        onClose: onClose
      })), /*#__PURE__*/_jsx(ExplicitSaveControls, {
        className: props.showRefAndTargetControls ? 'm-top-3' : 'm-top-5',
        popoverType: popoverType,
        isSubmitDisabled: isSubmitDisabled,
        linkType: linkType,
        onSubmit: handleSubmit,
        onCancel: onClose,
        renderLinkPopoverAlert: renderLinkPopoverAlert
      })]
    })
  }));
}
MorphingLinkPopoverBody.propTypes = propTypes;
MorphingLinkPopoverBody.displayName = 'MorphingLinkPopoverBody';
export default MorphingLinkPopoverBody;